export default function GoogleGeminiIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4"
      aria-label="google logo"
      tabIndex={-1}
      role="img"
    >
      <g id="Provider">
        <path
          d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
          fill="white"
        ></path>
        <path
          id="Vector"
          d="M14 7.91239C12.4431 8.00793 10.975 8.66948 9.87203 9.77242C8.76909 10.8754 8.10754 12.3435 8.012 13.9004H7.988C7.89262 12.3435 7.23112 10.8752 6.12815 9.77224C5.02519 8.66927 3.55691 8.00777 2 7.91239L2 7.88839C3.55691 7.79301 5.02519 7.13151 6.12815 6.02854C7.23112 4.92558 7.89262 3.4573 7.988 1.90039L8.012 1.90039C8.10754 3.45725 8.76909 4.92543 9.87203 6.02837C10.975 7.1313 12.4431 7.79285 14 7.88839V7.91239Z"
          fill="url(#paint0_radial_4865_17007)"
        ></path>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_4865_17007"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.191 6.77764) rotate(18.6832) scale(12.7725 102.316)"
        >
          <stop
            offset="0.067"
            stop-color="#9168C0"
          ></stop>
          <stop
            offset="0.343"
            stop-color="#5684D1"
          ></stop>
          <stop
            offset="0.672"
            stop-color="#1BA1E3"
          ></stop>
        </radialGradient>
      </defs>
    </svg>
  );
}
